import { render, staticRenderFns } from "./IndisponivelPage.vue?vue&type=template&id=58ca0471&scoped=true"
import script from "./IndisponivelPage.vue?vue&type=script&lang=js"
export * from "./IndisponivelPage.vue?vue&type=script&lang=js"
import style0 from "./IndisponivelPage.vue?vue&type=style&index=0&id=58ca0471&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ca0471",
  null
  
)

export default component.exports